import * as t from "./actionTypes";

export const showLoggedOutMessage = (_statusCode, _url, _body) => {
  return {
    type: t.SHOW_LOGGED_OUT_MESSAGE,
  };
};

export const show5xxResponseErrorMessage = (statusCode, url, body) => ({
  type: t.SHOW_REQUEST_FAILED_MESSAGE,
  meta: {
    mixpanel: {
      event: "Got 5xx response, showing request failed error message",
      props: {
        response_status_code: statusCode,
        response_url: url,
        response_body: body,
      },
    },
  },
});

export const showRequestPreflightErrorMessage = (url) => ({
  type: t.SHOW_REQUEST_FAILED_MESSAGE,
  meta: {
    mixpanel: {
      event: "Preflight cors request failed, showing request failed error message",
      props: {
        response_url: url,
      },
    },
  },
});

export const log4xxResponseError = (statusCode, url, body) => ({
  type: t.LOG_REQUEST_FAILED,
  meta: {
    mixpanel: {
      event: "Got 4xx response, will invoce error function for the request",
      props: {
        response_status_code: statusCode,
        response_url: url,
        response_body: body,
      },
    },
  },
});

export const hideLoggedOutMessage = () => ({
  type: t.HIDE_LOGGED_OUT_MESSAGE,
});
